import {AutoTableInterface} from "@/features/types/AutoTableInterface";

/** Typ dla numeru procesu (z pierwszego wiersza PaymDoc) */
export type ProcessNumberSource = {
    f_paym_ord_num?: string | null;
    f_paym_ord_user_name?: string | null;
    f_paym_ord_year?: string | null;
} | null;

/**
 * Zwraca wartość pola z wiersza AutoTable do wyświetlenia w modalu (szczegóły pojazdu).
 * Obsługuje m.in. f_vis_mark_7 jako TAK/NIE oraz puste wartości jako "-".
 */
export function getAutoDetailsDisplayValue(
    data: AutoTableInterface,
    key: keyof AutoTableInterface
): string {
    const value = data[key];
    if (key === "f_vis_mark_7") {
        return Number(value) === 1 ? "TAK" : "NIE";
    }
    if (value === null || value === undefined || value === "") {
        return "-";
    }
    if (typeof value === "number") {
        return value.toLocaleString("pl-PL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
    return String(value);
}

/**
 * Formatowanie wartości komórki w tabelach w modalu (Opcje, Sprzedaż).
 * Liczby → pl-PL z 2 miejscami, puste → "-".
 */
export function formatDetailsTableCellValue(rawValue: unknown): string {
    if (typeof rawValue === "number") {
        return rawValue.toLocaleString("pl-PL", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
    if (rawValue === null || rawValue === undefined || rawValue === "") {
        return "-";
    }
    return String(rawValue);
}

/**
 * Zwraca numer procesu w formacie "num / user / year" do jednego pola readonly w tabie Sprzedaż.
 * Źródło: pierwszy wiersz tabeli PaymDoc (dane z bazy PaymDocTable, nie z AutoTable).
 */
export function getProcessNumberDisplayValue(row: ProcessNumberSource): string {
    if (!row) return "-";
    const num = row.f_paym_ord_num ?? "";
    const user = row.f_paym_ord_user_name ?? "";
    const year = row.f_paym_ord_year ?? "";
    const parts = [num, user, year].filter((s) => s !== "");
    if (parts.length === 0) return "-";
    return parts.join("/");
}
